import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyDyDqLukoXZiny51Iv_2Cq8Cat6uDotgWM",
  authDomain: "homeschoolingwithj-d3193.firebaseapp.com",
  projectId: "homeschoolingwithj-d3193",
  storageBucket: "homeschoolingwithj-d3193.firebasestorage.app",
  messagingSenderId: "268875260854",
  appId: "1:268875260854:web:464433c7670b37e4611717",
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);